export default "__VITE_ASSET__2f6b0296__"